module.exports = __webpack_public_path__ + "static/img/arrow_left.58fdc999.svg";